module.exports = __webpack_public_path__ + "media/images/places/img_ceremony-ed2c0f19a1f7d3b0208889e05dc622f8.png";